module.exports = __webpack_public_path__ + "img/PE.ef4b18d8.webp";